import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_mgmt_tried_to_control_manipulate_or_interfere_w_any'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_mgmt_tried_to_control_manipulate_or_interfere_w_any',
  name: 'Has the facility management tried to control, manipulate or interfere with any of the unions in the facility?',
  description:
    "Union presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nInterference is indicated when the employer:\r\r\n- takes action in an effort to dominate, control or undermine workers' organizations\r\r\n- is involved in union decision-making, in the formation of the constitution and rules, in union activities, administration, finances or elections\r\r\n- tries to gain control of the union by financing it in a way that is not intended by national law\r\r\n- tries to undermine the union by offering bribes to union activists to withdraw from the union, or by artificially promoting them in an effort to impede their participation in union affairs\r\r\n- provides incentives to workers to keep them from joining a trade union or engaging in trade union activities, and/or\r\r\n- promotes the formation of a workers' organization to compete against existing union(s)\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-4--3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12210,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
